import { render, staticRenderFns } from "./folders-ports-countries.vue?vue&type=template&id=152b0c1d&scoped=true"
import script from "./folders-ports-countries.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b0c1d",
  null
  
)

export default component.exports